import { render, staticRenderFns } from "./dialog_sendCard.vue?vue&type=template&id=55e12d97&scoped=true&"
import script from "./dialog_sendCard.vue?vue&type=script&lang=js&"
export * from "./dialog_sendCard.vue?vue&type=script&lang=js&"
import style0 from "./dialog_sendCard.vue?vue&type=style&index=0&id=55e12d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e12d97",
  null
  
)

export default component.exports